import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class SharedProvider {
  dateInputFormat:string = 'dd/MM/yyyy'; // Default format
    dateOutputFormat: string = 'dd/MM/yyyy'; // Default format
    dateOutputLongFormat: string = 'dd MMM yyyy'; // Default format
  // gazetteerAPI!: string;

  setDateInputFormat(value: string) {
    this.dateInputFormat = value;
  }

  setDateOutputFormat(value: string) {
    this.dateOutputFormat = value;
    }

  setDateOutputLongFormat(value: string) {
    this.dateOutputFormat = value;
  }


  // setGazetteerAPI(value: string) {
  //     this.gazetteerAPI = value;
  // }

  get() {
    return {
        DateOutputLongFormat: this.setDateOutputLongFormat,
      DateOutputFormat: this.dateOutputFormat,
      DateInputFormat: this.dateInputFormat,
      // GazetteerAPI: this.gazetteerAPI
    };
  }
}
